import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ImageSlider from "./ImageSlider";
import {getLocation} from "../../../services/locations/api";
import MediaModal from "../../../components/modal/MediaModal";
import moment from "moment";

/**
 * Review Images
 * A component that manages images for reviews on a review.
 */
const ReviewImages = (props) => {
  const { images, contentProvider, locationId, reviewDate } = props.review;
  const [modalState, setModalState] = useState({isOpen: false, selectedIdx: 0});
  const [location, setLocation] = useState();

  useEffect(() => {
    if (!location) getLocation(locationId).then(loc => setLocation(loc));
  }, []);

  const keyedImages = images
    ? images.map((url, idx) => { return { idx, imageUrl: url }; })
    : [];

  const onImageClick = (image) => setModalState({ isOpen: !modalState.isOpen, selectedIdx: image.idx});
  const toggle = () => setModalState({...modalState, isOpen: !modalState.isOpen});

  return (
    <div className="w-100">
      <ImageSlider images={keyedImages} onImageClick={onImageClick} thumbnailSize={100} />
      { modalState.isOpen && <MediaModal
        isOpen={modalState.isOpen}
        toggle={toggle}
        images={keyedImages.map(x => x.imageUrl)}
        provider={contentProvider}
        location={location}
        reviewDate={moment(reviewDate)}
        startIndex={modalState.selectedIdx}
      /> }
    </div>
  );
};

ReviewImages.propTypes = { review: PropTypes.object.isRequired };

export default ReviewImages;
